// src/app/components/audit-status/audit-status.component.ts
import { Component, Input } from '@angular/core';
import { AuditStatus } from '../../api';

@Component({
  selector: 'ui-audit-status',
  // DOCU-1167: status as chip with the shared status pairs (tokens, same as the app).
  template: `
    <span class="docuty-chip" [ngClass]="containerClass">
      <mat-icon>{{ icon }}</mat-icon>
      {{ label | translate }}
    </span>
  `
})
export class AuditStatusComponent {
  @Input() status!: AuditStatus;

  get containerClass(): string {
    switch (this.status) {
      case AuditStatus.Progress: return 'docuty-chip--progress';
      case AuditStatus.Finish: return 'docuty-chip--done';
      case AuditStatus.Archived: return 'docuty-chip--archived';
      default: return 'docuty-chip--done';
    }
  }

  get icon(): string {
    switch (this.status) {
      case AuditStatus.Progress: return 'pending';
      case AuditStatus.Finish: return 'check_circle';
      case AuditStatus.Archived: return 'archive';
      default: return 'help_outline';
    }
  }

  get label(): string {
    switch (this.status) {
      case AuditStatus.Progress: return 'AUDIT.STATUS_DETAIL.PROGRESS';
      case AuditStatus.Finish: return 'AUDIT.STATUS_DETAIL.FINISH';
      case AuditStatus.Archived: return 'AUDIT.STATUS_DETAIL.ARCHIVED';
      default: return 'AUDIT.STATUS_DETAIL.UNKNOWN';
    }
  }
}